import { type FC } from 'react';
import {
  Square
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconSquareProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconSquare: FC<UiIconSquareProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Square}
      {...props}
    />
  );
};
